import axios from '../utils/axios';

export default function getUnicornDataCount (adminId, params) {
    return axios.get(`/admin/${adminId}/get-record-count`, { params });
}